import React from "react";
import { connect } from 'react-redux';
import { Grid } from "semantic-ui-react";
import { Helmet } from "react-helmet";

const qlikLinks = {
    procurmentOverview:
        '<iframe src="https://qap.inenco.com/insite/extensions/PORTAL_Tradepoint/PORTAL_Tradepoint.html?qlikTicket=iaUr1KhGqhcmdDuv" style="border:none;max-width:100%!important;width:100%!important;height:1080px!important;"></iframe>'
};
 
function Iframe(props) {
    return (
        <div
            dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
        />
    );
}
 
const QLIKFRAME = props => (
    <div className='main-container'>
        <Helmet>
            <title>Inenco Portal | Procurement Centre</title>
        </Helmet>
        <Grid padded stackable columns='equal' style={{height: "100%"}}>
            <Grid.Row>
                <Grid.Column>
                    <h2>Procurement Centre</h2>
                </Grid.Column>
            </Grid.Row>

            <Grid.Row>
                <Grid.Column style={{height: "1120px", display: "block"}}>
                    <div className="App" style={{ height: '100%', position: 'absolute', left: '0px', width: '100%', overflow: 'auto' }}>
                        <Iframe iframe={qlikLinks["procurmentOverview"]} allow="autoplay" style={{ border:'none',width:'100%!important',height:'1080px!important'}} />
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </div>
);
 
export default connect()(QLIKFRAME);